import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import File from '@root/views/File/File';
import Loading from '@root/components/Loading/Loading';
import ShopifyDropDown from '@root/components/integrations/Shopify/ShopifyDropDown';
import ShopifyFormModal from '@root/components/integrations/Shopify/ShopifyFormModal';
import ShopifyProductSelect from '@root/components/integrations/Shopify/ShopifyProductSelect';
import useIntegration from '@root/resources/integrations/useIntegration';
import useProduct from '@root/resources/integrations/shopify-integration/useProduct';

import useStyles from './ProductDescription.styles';

const ProductDescriptionGenerator = () => {
  const classes = useStyles();
  const params = useParams();

  const [productSelectOpen, setProductSelectOpen] = useState(false);

  const { data: integration, isFetchingIntegration, refetch } = useIntegration('shopify');
  const { data } = useProduct(params.id);

  if (isFetchingIntegration) {
    return <Loading />;
  }

  return (
    <File
      documentControls={['selectAll', 'example', 'plagiarismCheck', 'share', 'export', 'settings']}
      id={params.id}
      templateType="productDescription"
      integration={{
        renderPanelComponent: ({ toggleIntegrationModal }, currentUser) => {
          return currentUser.permissions.shopify && (
            <ShopifyDropDown
              setSelectingProduct={() => setProductSelectOpen(!productSelectOpen)}
              openModal={toggleIntegrationModal}
            />
          );
        },
        showControls: true,
        formClass: data?.product?.image?.src && classes.formVertical,
        renderCustomForm: ({ reloadData }) => (
          integration && productSelectOpen ? (
            <ShopifyProductSelect
              close={() => setProductSelectOpen(!productSelectOpen)}
              documentId={params.id}
              reloadData={reloadData}
            />
          ) : (
            data?.product?.image?.src && (
              <img
                src={data ? data.product?.image?.src : null}
                alt=""
                className={classes.image}
              />
            )
          )
        ),
        formHidden: productSelectOpen,
        renderCustomModal: ({
          integrationModalOpen,
          toggleIntegrationModal,
        }) => (
          <div>
            <ShopifyFormModal
              isOpen={integrationModalOpen}
              close={() => {
                toggleIntegrationModal();
              }}
              closeAndShowProducts={() => {
                toggleIntegrationModal();
                setProductSelectOpen(true);
                refetch();
              }}
            />
          </div>
        ),
      }}
    />
  );
};

export default ProductDescriptionGenerator;
